export default __webpack_public_path__ + "static/media/ash-now.bf21d708.gif";